import { Badge } from "@/components/ui/badge";
import { signalLabels } from "@/modules/collector_v2/lib/constants";

export function SignalBadge({ type }) {
  return (
    <Badge data-testid="signal-type-badge" variant="outline" className="signal-badge">
      {signalLabels[type] || type}
    </Badge>
  );
}
